export class EonOrganization {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "userPoolId",
            "baseName": "userPoolId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cognitoClientId",
            "baseName": "cognitoClientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cognitoDomain",
            "baseName": "cognitoDomain",
            "type": "string",
            "format": ""
        },
        {
            "name": "mfaEnabled",
            "baseName": "mfaEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EonOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
